<template>
  <div class="login-bg-color">
    <div class="login-header">
      <a href="/indexs" class="logo-box"><img src="../../assets/img/logos.png" alt=""></a>
      <div>
<!--        <span><i class="iconfont iconkefu"></i>服务电话：400-999-6541</span>-->
        <a href="/indexs" class="yellow-btn" style="border-radius: 50px;">返回首页</a>
      </div>
    </div>
    <div class="login-bg">
      <div class="input-box">
        <slot name="content"></slot>
      </div>
    </div>
    <div class="footer">
      <div class="width-100 flex justify-between align-center padding-top-sm foot-container">
        <div class="flex align-center">
          <i class="service-icon iconfont icondianhua"></i>
          <div class="flex flex-direction margin-left-sm">
            <div class="service-phone">服务电话：400-999-6541</div>
            <div class="service-day">周一至周日8:00-20:00</div>
          </div>
        </div>
        <div class="flex">
          <div class="flex flex-direction align-center">
            <img src="../../assets/img/erweima_zf.png" alt="" class="scan">
            <div class="scan-tag">免费获取更多社会组织服务</div>
          </div>
          <div class="flex flex-direction align-center margin-left">
            <img src="../../assets/img/erweima_emof.jpg" alt="" class="scan">
            <div class="scan-tag">了解更多信息化产品</div>
          </div>
        </div>
      </div>
      <div class="footer-text">Copyright 益魔方   <a style="color: #fff" href="https://beian.miit.gov.cn/" target="_blank">京ICP备15038897号-3</a>
        <a data-v-23f1b31c="" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214" target="_blank" class="margin-lr-xs" style="color: rgb(255, 255, 255);"><img data-v-23f1b31c="" data-v-45865956="" src="http://www.beian.gov.cn/img/new/gongan.png" alt="">公安备案号：11010802038214</a>
        北京易魔方科技集团有限公司 版权所有
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "box"
}
</script>

<style scoped lang="scss">
.login-bg-color {
  background: #0a2240;
}

.login-header {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo-box {
    display: flex;
    align-items: center;
    height: 100%;

    img {
      height: 52px;
    }
  }

  div {
    display: flex;
    align-items: center;

    span {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #fff;
      height: 40px;
      line-height: 40px;
      margin-right: 20px;
      padding: 0 10px;
      background-color: #0a2240;
      border-radius: 15px;
      text-align: center;

      i {
        font-size: 24px;
        margin-right: 10px;
      }
    }

    a {
      display: block;
      font-size: 16px;
      color: #fff;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      background-color: #0a2240;
      border-radius: 15px;
      text-align: center;
    }
  }
}

.login-bg {
  width: 100%;
  height: 740px;
  padding: 80px;
  background: url(../../assets/img/loginbg.png) no-repeat center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .input-box {
    width: 1200px;
    margin: 0 auto;
    height: 740px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.footer {
  width: 100%;

  z-index: 1;
}

.foot-container {
  width: 1200px;
  padding-bottom: 15px;
  margin: 0 auto;

  .logo {
    margin: 20px 0;
    height: 40px;
  }

  .scan {
    width: 75px;
    height: 75px;
    border-radius: 5px;
  }

  .scan-tag {
    font-size: 10px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;
    margin-top: 10px;
  }

  .service-icon {
    font-size: 27px;
    color: #ffffff;
  }

  .service-phone {
    font-size: 16px;
    color: #ffffff;
    line-height: 20px;
  }

  .service-day {
    font-size: 12px;
    color: #ffffff;
    opacity: 0.5;
  }

  .link {
    font-size: 16px;
    color: #ffffff;
  }

  .info {
    font-size: 12px;
    margin-top: 5px;
    padding: 10px 0;
    color: #ffffff;

    a {
      font-size: 12px;
      color: #ffffff;
    }
  }
}

.footer-text {
  height: 40px;
  line-height: 40px;
  background: #0a2240;
  text-align: center;
  color: #fff;
  font-size: 12px;
}
</style>
